(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/news/assets/javascripts/views/news-article.js') >= 0) return;  svs.modules.push('/components/sport/news/assets/javascripts/views/news-article.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs.sport.news.views.NewsArticle = Backbone.Marionette.View.extend({
    tagName: 'li',
    className:
      'f-content-default news-article relative padding-1 margin-bottom-1',
    localStorageID: 'news-article',

    const: {
      NO_OF_COLLAPSED_ROWS: 3
    },

    getTemplate: function() {
      return svs.sport.news.templates.news_article;
    },

    events: {
      'click .js-collapse-button': 'toggleExpand',
      'click .js-nav-btn': 'navigate'
    },

    ui: {
      contentPanel: '.content',
      cover: '.cover',
      newsTime: 'news-article-time'
    },

    initialize: function() {
      this.localStorageID += '-' + this.cid;
    },

    onRender: function() {
      this.detectInitialState();
      if (this.model.collection.indexOf(this.model) === 0) {
        this.$el.addClass('news-article-first');
      }

      var self = this;
      setTimeout(function() {
        self.findCollapsedHeight();
      }, 1);
    },

    findCollapsedHeight: function() {
      var spaces = this.$el.find('.content-space');
      var firstParagraph = this.$el.find('p')[0];
      var row = 0;
      var offsetTop = null;
      for (var i in spaces) {
        if (Object.prototype.hasOwnProperty.call(spaces, i)) {
          try {
            if (offsetTop !== spaces[i].offsetTop) {
              offsetTop = spaces[i].offsetTop;
              row++;
            }
          } catch (e) {
          }
          if (!!firstParagraph && spaces[i].parentElement !== firstParagraph) {
            $(firstParagraph).append(
              '<span class="content-space collapse-breakpoint"> </span>'
            );
            if (!this.$el.hasClass('news-article-expanded')) {
              this.$el.find('.collapse-breakpoint').html(' ... <br /><br />');
            }
            break;
          } else if (row > this.const.NO_OF_COLLAPSED_ROWS) {
            $(spaces[i - 2]).addClass('collapse-breakpoint');
            if (!this.$el.hasClass('news-article-expanded')) {
              $(spaces[i - 2]).html(' ... <br /><br />');
            }
            break;
          }
        }
      }
    },

    toggleExpand: function() {
      var content = this.ui.contentPanel;
      if (content.hasClass('collapsed')) {
        this.setStateClasses(true);
      } else {
        this.setStateClasses(false);
      }
    },

    setStateClasses: function(open) {
      if (open) {
        this.$el.addClass('news-article-expanded');
        this.ui.contentPanel.removeClass('collapsed');
        svs.components.Storage.browser.set(
          this.localStorageID,
          'svs',
          JSON.stringify({ expanded: true })
        );
        this.$el.find('.collapse-breakpoint').html(' ');
      } else {
        this.$el.removeClass('news-article-expanded');
        this.ui.contentPanel.addClass('collapsed');
        svs.components.Storage.browser.set(
          this.localStorageID,
          'svs',
          JSON.stringify({ expanded: false })
        );
        this.$el.find('.collapse-breakpoint').html(' ... <br /><br />');
      }
    },

    detectInitialState: function() {
      var rawData = svs.components.Storage.browser.get(
          this.localStorageID,
          'svs'
        ),
        data;

      if (rawData) {
        data = JSON.parse(rawData);
      }

      this.setStateClasses(_.isObject(data) && data.expanded);
    },

    setInitialState: function(open, optOverride) {
      var rawData = svs.components.Storage.browser.get(
          this.localStorageID,
          'svs'
        ),
        data;

      if (rawData) {
        data = JSON.parse(rawData);
      }

      if (!_.isObject(data) || optOverride) {
        this.setStateClasses(open);
      }
    },

    destroy: function() {
      this.stopListening();
    }
  });
})(Backbone, _, svs);

 })(window);